import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { resetIdleTimer } from '../services/authService';

function IdleTimeoutWrapper({ children }) {
  const location = useLocation();

  useEffect(() => {
    // Events that indicate user activity
    const events = [
      'mousedown',
      'mousemove',
      'keypress',
      'scroll',
      'touchstart',
      'click',
      'keydown'
    ];

    // Reset timer on any user activity
    const handleActivity = () => {
      resetIdleTimer();
    };

    // Add event listeners
    events.forEach(event => {
      window.addEventListener(event, handleActivity);
    });

    // Reset timer on route change
    resetIdleTimer();

    // Cleanup
    return () => {
      events.forEach(event => {
        window.removeEventListener(event, handleActivity);
      });
    };
  }, [location]);

  return children;
}

export default IdleTimeoutWrapper;
